import JxButton from '../../../JxControls/JxButtons/JxButton';

/**
 * UmlSchemaStartTab — entry-keuze van de dialog: New of Load Existing.
 * Puur presentationeel, geen eigen state — acties komen van UmlSchemaConfigDlg
 * (handleNew/handleOpenLoadDlg), die ook de tab-switch naar Properties regelt.
 * @param {{ onNew: Function, onOpenLoadDlg: Function }} props
 */
export default function UmlSchemaStartTab({ onNew, onOpenLoadDlg }) {
    return (
        <div className="usd-start">
            <div className="usd-start-text">Start a new UmlWorkspace schema, or load an existing one.</div>
            <div className="usd-start-actions">
                <JxButton className="jx-button-sm" label="New" onClick={onNew} />
            </div>

            <div className="usd-start-actions">
                <JxButton className="jx-button-sm" label="Load Existing" onClick={onOpenLoadDlg} />
            </div>
        </div>
    );
}
